import React from "react";
import { FCard, FItem } from "ferrum-design-system";
import {
  useAlgoSignerWalletConnector,
  useKeplrWalletConnector,
  useWalletConnector,
} from "foundry";
import { getFormattedWalletLastAddress } from "../global.utils";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";

export const ConnectWalletsInfo = ({ onClick }: any) => {
  const { walletAddress, isConnected } = useWalletConnector();
  const { isAlgoConnected, connectedAlgorandWalletAddress } =
    useAlgoSignerWalletConnector();
  const { isKeplrConnected, connectedKeplrWalletAddress } =
    useKeplrWalletConnector();
  const { connectedNetwork } = useSelector(
    (state: RootState) => state.networks
  );

  return (
    <>
      {(walletAddress && isConnected) ||
      (isKeplrConnected &&
        connectedKeplrWalletAddress &&
        connectedKeplrWalletAddress !== "") ||
      (isAlgoConnected &&
        connectedAlgorandWalletAddress &&
        connectedAlgorandWalletAddress !== "") ? (
        <div
          className="ms-connected-wallets-info cursor-pointer"
          onClick={onClick}
        >
          {isConnected && walletAddress && (
            <>
              <FItem
                display={"flex"}
                alignY="center"
                className="no-left-margin"
              >
                <FCard
                  variant={"secondary"}
                  className={
                    "d-flex custom-padding-10 overflow-visible wallet-amount-card"
                  }
                >
                  <div style={{ width: 24, height: 24 }}>
                    <img
                      src={connectedNetwork?.logo}
                      height="25px"
                      width="25px"
                      alt=""
                    />
                  </div>
                  <span className={"f-pl--2"}>
                    {getFormattedWalletLastAddress(walletAddress)}
                  </span>
                </FCard>
              </FItem>
            </>
          )}
          {walletAddress &&
            isAlgoConnected &&
            connectedAlgorandWalletAddress &&
            connectedAlgorandWalletAddress !== "" && (
              <div className="ms-connected-wallets-info-hr" />
            )}
          {isAlgoConnected &&
            connectedAlgorandWalletAddress &&
            connectedAlgorandWalletAddress !== "" && (
              <FItem
                display={"flex"}
                alignY="center"
                className="no-left-margin"
              >
                <FCard
                  variant={"secondary"}
                  className={
                    "d-flex custom-padding-10 overflow-visible wallet-amount-card"
                  }
                >
                  <div style={{ width: 24, height: 24 }}>
                    <img
                      src={connectedNetwork?.logo}
                      height="25px"
                      width="25px"
                      alt=""
                    />
                  </div>
                  <span className={"f-pl--2"}>
                    {getFormattedWalletLastAddress(
                      connectedAlgorandWalletAddress
                    )}
                  </span>
                </FCard>
              </FItem>
            )}
          {isKeplrConnected &&
            connectedKeplrWalletAddress &&
            connectedKeplrWalletAddress !== "" && (
              <FItem
                display={"flex"}
                alignY="center"
                className="no-left-margin"
              >
                <FCard
                  variant={"secondary"}
                  className={
                    "d-flex custom-padding-10 overflow-visible wallet-amount-card"
                  }
                >
                  <div style={{ width: 24, height: 24 }}>
                    <img
                      src={connectedNetwork?.logo}
                      height="25px"
                      width="25px"
                      alt=""
                    />
                  </div>
                  <span className={"f-pl--2"}>
                    {getFormattedWalletLastAddress(connectedKeplrWalletAddress)}
                  </span>
                </FCard>
              </FItem>
            )}
        </div>
      ) : null}
    </>
  );
};
